import React from 'react';
import { RequestConfirmation } from 'Organisms/RequestConfirmationPage';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';

export const InsightRequestConfirmation = () => {
  const { resource } = useMetaLayoutContext();

  return (
    <RequestConfirmation resource={resource} />
  );
};
